export class Page {
    size: number;
    totalElements: number;
    totalPages: number;
    number: number;

    constructor(pageData: { size: number; totalElements: number; totalPages: number; number: number }) {
        this.size = pageData.size;
        this.totalElements = pageData.totalElements;
        this.totalPages = pageData.totalPages;
        this.number = pageData.number;
    }
}
